import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { defineLocale, roLocale, ruLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { LangService } from './core/services/lang.service';

@Component({
  selector: 'app-cabinet',
  imports: [RouterOutlet, RouterModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  @Input() lang: string = '';
  title = 'paynet-spa-oplata_md-cabinet';
  translate = inject(TranslateService);
  localeService = inject(BsLocaleService);
  langService = inject(LangService);
  constructor() {
    defineLocale('ro', roLocale);
    defineLocale('ru', ruLocale);
  }

  ngOnInit(): void {
    if (this.lang) {
      this.langService.setLang(`${this.lang}-${this.lang.toUpperCase()}`);
      this.localeService.use(this.lang);
      this.translate.use(this.lang);
    } else {
      this.langService.setLang('ro-RO');
      this.localeService.use('ro');
      this.translate.use('ro');
    }
  }
}
